module.exports = __webpack_public_path__ + "static/media/AVISO.128da6dc.svg";